import CheckboxSelectionProcessor from '../../Components/Core/Processors/CheckboxSelectionProcessor'
import CheckBoxSelectionResultProcessor from '../../Components/Core/SelectionResults/CheckBoxSelectionResultProcessor'
import QuinellaValidator from '../../Validation/QuinellaValidator'
import BetTypeInformation from '../Betting/BetTypeInformation'
import type { IConfigureBetType } from './IConfigureBetType'

export default class QuinellaConfigurator implements IConfigureBetType {
  build(): BetTypeInformation {
    return new BetTypeInformation({
      betType: 'Quinella',
      name: 'Quinella',
      supportsFlexi: true,
      sortOptions: ['Number', 'FixedPrice', 'Price'],
      template: 'quinella-template',
      betSelectionTemplate: 'dual-checkbox-selection-template',
      multiBet: false,
      multiSelections: true,
      checkBoxCount: 1,
      fieldCheckBoxCount: 1,
      sameAsCheckBoxCount: 0,
      processor: new CheckboxSelectionProcessor(1),
      validator: new QuinellaValidator(),
      selectionResultProcessor: new CheckBoxSelectionResultProcessor(2),
      legs: 1,
    })
  }
}
